import { render } from "./activity-detail.vue?vue&type=template&id=e4c57b86"
import script from "./activity-detail.vue?vue&type=script&lang=js"
export * from "./activity-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__